module.exports = __webpack_public_path__ + "img/b5-2.2b978cb.png";